module.exports = __webpack_public_path__ + "img/l-hd.d930a6a3.jpg";